import React from 'react';

const About = () => {
  const certifications = [
    {
      title: 'Diploma in Fashion Designing',
      institution: 'Lakhotia Institute of Art & Design',
      date: 'April 30, 2007',
      certificateNo: 'PRO/UP/4779',
      grade: 'E+',
      description: 'Comprehensive training in fashion design principles, pattern making, and garment construction'
    },
    {
      title: 'ESDP Fashion Designing Training',
      institution: 'MSME Development Institute, Kanpur',
      date: 'July 17 - August 28, 2008',
      certificateNo: 'ESDP/2008/2505',
      description: 'Government-certified vocational training program in fashion designing and skill development'
    },
    {
      title: 'Certificate in Fashion Designing',
      institution: 'Lakhotia Institute of Art & Design',
      date: 'December 30, 2008',
      certificateNo: 'PROJUP/4775',
      grade: 'E+',
      description: 'Advanced training certification in fashion designing techniques and industry practices'
    },
    {
      title: 'National Trade Certificate - Sewing Technology',
      institution: 'National Council for Vocational Training (NCVT)',
      date: 'September 16, 2016',
      certificateNo: '1509205855',
      description: 'Government of India certified trade test in Sewing Technology - All India Trade Test passed'
    }
  ];

  return (
    <div className="pt-20" data-testid="about-page">
      {/* Hero Section */}
      <section className="relative h-[60vh] bg-cover bg-center" 
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/8886939/pexels-photo-8886939.jpeg)' }}
      >
        <div className="absolute inset-0 bg-[#2B2B2B] bg-opacity-60"></div>
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div>
            <h1 className="font-playfair text-5xl sm:text-6xl lg:text-7xl text-[#F8F6F0] mb-4">
              About Our Founder
            </h1>
            <p className="font-montserrat text-lg text-[#D4AF37] tracking-widest">
              A Journey of Passion and Excellence
            </p>
          </div>
        </div>
      </section>

      {/* Founder Profile */}
      <section className="py-20 px-4 bg-[#F8F6F0]" data-testid="founder-profile">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="font-playfair text-4xl sm:text-5xl text-[#2B2B2B] mb-6">
                Shikha Tripathi
              </h2>
              <p className="font-montserrat text-base leading-relaxed text-[#2B2B2B] mb-4">
                With over 15 years of experience in the fashion industry, Shikha Tripathi has established 
                herself as a leading name in designer salwar suits and ethnic wear. Her journey began with a simple 
                passion for creating comfortable yet elegant daily wear that celebrates Indian craftsmanship 
                while embracing contemporary design.
              </p>
              <p className="font-montserrat text-base leading-relaxed text-[#2B2B2B] mb-4">
                Born and raised in a family of textile artisans, Shikha learned the intricate art of 
                embroidery and fabric work from her grandmother. This early exposure to traditional 
                craftsmanship shaped her design philosophy - creating pieces that modern women can wear 
                with confidence every day.
              </p>
              <p className="font-montserrat text-base leading-relaxed text-[#2B2B2B]">
                Today, Krystal Apparel Store stands as a testament to her vision: creating premium salwar suits 
                that combine elegance with comfort, traditional embroidery with modern silhouettes, and quality 
                craftsmanship with accessible pricing. Every piece is designed to make you feel beautiful, 
                confident, and comfortable.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative">
                <img 
                  src="https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/tefkx1pw_Gemini_Generated_Image_qrjtqjqrjtqjqrjt.png" 
                  alt="Shikha Tripathi - Founder" 
                  className="w-full h-auto rounded-lg shadow-2xl"
                  data-testid="founder-photo"
                />
                <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#D4AF37] opacity-20 rounded-lg -z-10"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Grid */}
      <section className="py-20 px-4 bg-white" data-testid="certifications-section">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-playfair text-4xl sm:text-5xl text-[#2B2B2B] text-center mb-12">
            Professional Certifications
          </h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div 
                key={index}
                className="bg-[#F8F6F0] p-6 rounded-lg border-l-4 border-[#D4AF37] hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                data-testid={`certification-card-${index}`}
              >
                <div className="mb-4">
                  <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mb-3">
                    <svg className="w-6 h-6 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                  </div>
                  <h3 className="font-playfair text-lg text-[#2B2B2B] mb-2 leading-snug">
                    {cert.title}
                  </h3>
                  <p className="font-montserrat text-xs text-[#D4AF37] font-semibold mb-2">
                    {cert.institution}
                  </p>
                  <p className="font-montserrat text-xs text-[#2B2B2B] mb-2">
                    {cert.date}
                  </p>
                  {cert.certificateNo && (
                    <p className="font-montserrat text-xs text-[#2B2B2B] mb-2">
                      Cert. No: {cert.certificateNo}
                    </p>
                  )}
                  {cert.grade && (
                    <p className="font-montserrat text-xs text-[#2B2B2B] font-semibold mb-2">
                      Grade: {cert.grade}
                    </p>
                  )}
                  <p className="font-montserrat text-xs text-[#2B2B2B] leading-relaxed mt-3">
                    {cert.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-20 px-4 bg-[#2B2B2B]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-playfair text-4xl sm:text-5xl text-[#D4AF37] mb-8">
            Our Mission
          </h2>
          <p className="font-montserrat text-lg text-[#F8F6F0] leading-relaxed">
            To preserve and celebrate the rich heritage of Indian textile arts while empowering the next 
            generation of designers and tailors through education, innovation, and sustainable practices. 
            We believe that every garment should tell a story, and every stitch should honor tradition.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
